import API from "@services/axios";
import moment from "moment-timezone";

const headerTop = () => {
  var wrapper = document.querySelector(".wrapper");
  if (wrapper !== null) {
    var header_h = document.getElementById("header").offsetHeight;
    wrapper.style.paddingTop = header_h + "px";
  }
};

const closeMobileMenu = () => {
  document.body.classList.remove("open-menu");
};

const setUserId = (data) => {
  localStorage.setItem("id", data);
};

const getUserId = () => {
  return localStorage.getItem("id");
};

const setUserData = (data) => {
  localStorage.setItem("data", data);
};

const getUserData = () => {
  return localStorage.getItem("data");
};

const removeUserData = () => {
  return localStorage.removeItem("data");
};

const setFilter = (filter, data, stringify) => {
  if (stringify) return localStorage.setItem(filter, JSON.stringify(data));
  else return localStorage.setItem(filter, data);
};
const getFilter = (filter, parse) => {
  if (parse) {
    return JSON.parse(localStorage.getItem(filter));
  } else {
    return localStorage.getItem(filter);
  }
};

const removeFilter = (filter) => {
  return localStorage.removeItem(filter);
};

const setToken = (token) => {
  localStorage.setItem("token", token);
};

const getToken = () => {
  return localStorage.getItem("token");
};

const removeToken = () => {
  return localStorage.removeItem("token");
};

const setPermissions = (permission) => {
  localStorage.setItem("permissions", permission);
};

const getPermissions = () => {
  const permissions = localStorage.getItem("permissions");
  const data = permissions !== null && permissions.split(",");
  return data;
};

const isRolePermission = (array, permissionName) => {
  for (let element of array) {
    const item = element.split("_");
    if (item[0] === permissionName) {
      return true;
    }
  }
  return false;
}

const actionFromPermission = (array, permissionName) => {
  for (let element of array) {
    const item = element.split("_");
    if (item[0] === permissionName) {
      return parseInt(item[1]);
    }
  }
  return -1;
}

const removePermissions = () => {
  return localStorage.removeItem("permissions");
};

const allowOnlyNumbers = (event) => {
  if (event.key.length === 1 && /\D/.test(event.key)) {
    event.preventDefault();
  }
};

function requestStatusColors(data) {
  var color;
  switch (data) {
    case "Requested":
      color = "requested";
      break;
    case "Acknowledged":
      color = "acknowledged";
      break;
    case "Driver Assigned":
      color = "driver-assigned";
      break;
    case "Request Completed":
      color = "request-completed";
      break;

    default:
      color = "#e40000";
      break;
  }
  return color;
}

const dashboardRequestStatusColors = (data) => {
  var color;
  switch (data) {
    case "Not Assigned":
      color = "not-assigned";
      break;
    case "Completed":
      color = "completed";
      break;
    case "Rejected":
      color = "rejected";
      break;
    case "In Transit":
      color = "in-progress";
      break;
    case " Lodgement":
      color = "in-progress";
      break;
    case "Loading":
      color = "in-progress";
      break;
    case "Unloading":
      color = "in-progress";
      break;
    case "Assigned":
      color = "assigned";
      break;
    case "Review Completed":
      color = "review-completed";
      break;

    default:
      color = "#e40000";
      break;
  }
  return color;
};

const dashboardRequestbButtonStyle = (data) => {
  var button;
  switch (data) {
    case "Not Assigned":
      button = "re-assign";
      break;
    case "Complete":
      button = "assign-driver";
      break;
    case "Rejected":
      button = "assign-driver";
      break;
    case "In Progress":
      button = "re-assign";
      break;

    default:
      button = "#e40000";
      break;
  }
  return button;
};

const jobListingRequestStyle = (data) => {
  var button;
  switch (data) {
    case "Assign Driver":
      button = "assign-driver";
      break;
    case "Re-Assign":
      button = "re-assign";
      break;
    default:
      button = "#e40000";
      break;
  }
  return button;
};

const makeid = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const getCustomDate = (to, from) => {
  const toDate = `${to.getDate()}/${to.getMonth() + 1}/${to.getFullYear()}`;
  const fromDate = `${from.getDate()}/${
    from.getMonth() + 1
  }/${from.getFullYear()}`;

  return `${toDate} - ${fromDate}`;
};

const getCustomFormToDate = (to, from) => {
  const toDate = moment(to).format("YYYY/MM/DD");
  const fromDate = moment(from).format("YYYY/MM/DD");
  return `${toDate} - ${fromDate}`;
};

const getCustomFormToDateFormat = (to, from) => {
  const toDate = moment(to).format("DD/MM/YYYY");
  const fromDate = moment(from).format("DD/MM/YYYY");
  return `${toDate} - ${fromDate}`;
};

function hasDecimalPlace(value, x) {
  var pointIndex = value.indexOf(".");
  return pointIndex >= 0 && pointIndex < value.length - x;
}
const allowOnlyFloat = (e) => {
  var newValue = e.target.value;
  if (hasDecimalPlace(newValue, 2) === false) {
    var ASCIICode = e.which ? e.which : e.keyCode;
    if (ASCIICode === 46) {
      if (newValue.split(".").length > 1 || e.target.selectionStart === 0) {
        e.preventDefault();
        e.returnValue = false;
      } else {
      }
    } else if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
      e.preventDefault();
    }
  } else {
    if(newValue.split(".").length > 1 && newValue.length - 3 >= e.target.selectionStart) {
      var ASCIICode = e.which ? e.which : e.keyCode;
      if(ASCIICode < 48 || ASCIICode > 57) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
      e.returnValue = false;
    }
  }
};
const allowOnlyFloatFour = (e) => {
  var newValue = e.target.value;
  if (hasDecimalPlace(newValue, 4) === false) {
    var ASCIICode = e.which ? e.which : e.keyCode;
    if (ASCIICode === 46) {
      if (newValue.split(".").length > 1 || e.target.selectionStart === 0) {
        e.preventDefault();
        e.returnValue = false;
      } else {
      }
    } else if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
      e.preventDefault();
    }
  } else {
    if(newValue.split(".").length > 1 && newValue.length - 5 >= e.target.selectionStart) {
      var ASCIICode = e.which ? e.which : e.keyCode;
      if(ASCIICode < 48 || ASCIICode > 57) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
      e.returnValue = false;
    }
  }
};
const allowNegativeOnlyFloat = (e) => {
  var newValue = e.target.value;
  if (hasDecimalPlace(newValue, 2) === false) {
    var ASCIICode = e.which ? e.which : e.keyCode;
    if (ASCIICode === 46) {
      if (newValue.split(".").length > 1 || e.target.selectionStart === 0) {
        e.preventDefault();
        e.returnValue = false;
      } else {
      }
    } else if (
      ASCIICode > 45 &&
      ASCIICode > 31 &&
      (ASCIICode < 48 || ASCIICode > 57)
    ) {
      e.preventDefault();
    } if(
      (ASCIICode === 45 && (newValue.includes("-") || e.target.selectionStart !== 0))
      || (newValue.includes("-") && e.target.selectionStart === 0 && ASCIICode !== 45)
    ){
      e.preventDefault();
    }
  } else {
    if(newValue.split(".").length > 1 && newValue.length - 3 >= e.target.selectionStart) {
      var ASCIICode = e.which ? e.which : e.keyCode;
      if(
        (ASCIICode === 45 && (newValue.includes("-") || e.target.selectionStart !== 0))
        || (ASCIICode !== 45 && (ASCIICode < 48 || ASCIICode > 57))
        || (newValue.includes("-") && e.target.selectionStart === 0 && ASCIICode !== 45)
      ) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
      e.returnValue = false;
    }
  }
};
const allowOnlyCharacters = (event) => {
  var ASCIICode = event.charCode;
  if (
    (ASCIICode >= 65 && ASCIICode <= 90) ||
    (ASCIICode >= 97 && ASCIICode <= 122) ||
    ASCIICode === 32
  ) {
  } else {
    event.preventDefault();
  }
};

const allowAlphaNumeric = (e) => {
  var keyCode = e.keyCode || e.which;
  var pattern = /^[a-z\d\-_\s`~!@#$%^&*()=+{\[\]}\\|:;'"<,>./?]+$/i;
  var isValid = pattern.test(String.fromCharCode(keyCode));
  if (!isValid) {
    e.preventDefault();
  } else {
  }
};

const allowPasteAlphaNumeric = (e) => {
  var valuePaste = e.clipboardData.getData("text");
  var pattern = /^(?!.*--)[a-z\d\-_\s`~!@#$%^&*()=+{\[\]}\\|:;'"<,>./?]+$/i;
  var isValid = pattern.test(valuePaste);
  !isValid && e.preventDefault();
};

const allowNumberWithSpaceValidation = (e) => {
  var keyCode = e.keyCode || e.which;
  var pattern = /^[\d\-\s]+$/i;
  var isValid = pattern.test(String.fromCharCode(keyCode));
  if (!isValid) {
    e.preventDefault();
  } else {
  }
};

const allowPasteNumberWithSpaceValidation = (e) => {
  var valuePaste = e.clipboardData.getData("text");
  var pattern = /^[\d\-\s]+$/i;
  var isValid = pattern.test(valuePaste);
  !isValid && e.preventDefault();
};

const awbNumberValidation = (e) => {
  var keyCode = e.keyCode || e.which;
  var pattern = /^[\d\-\s]+$/i;
  var isValid = pattern.test(String.fromCharCode(keyCode));
  if (!isValid) {
    e.preventDefault();
  } else {
    e.target.value = e.target.value
      .replace(/[^\d]/g, "")
      .replace(/(.{3})/, "$1-")
      .trim();
  }
};

const allowOnlyAlphaNumericNoSpecialChar = (e) => {
  var keyCode = e.keyCode || e.which;
  var pattern = /^[a-z\d]+$/i;
  var isValid = pattern.test(String.fromCharCode(keyCode));
  if (!isValid) {
    e.preventDefault();
  } else {
  }
};

const allowSomeSpecialChar = (e) => {
  var keyCode = e.keyCode || e.which;
  var pattern = /^[)(a-z\d\-_,.:;'°&/\s]+$/i;
  var isValid = pattern.test(String.fromCharCode(keyCode));
  if (!isValid) {
    e.preventDefault();
  } else {
  }
};

const pathValidation = (e) => {
  var keyCode = e.keyCode || e.which;
  var pattern = /^[)(a-z\d:/\s]+$/i;
  var isValid = pattern.test(String.fromCharCode(keyCode));
  if (!isValid) {
    e.preventDefault();
  } else {
  }
};

function convertMinutesToHours(value) {
  var Hours = Math.floor(value / 60);
  var minutes = value % 60;
  return `${Hours} : ${minutes}`;
}
function averageMinutesToHours(value) {
  var Hours = parseFloat(value / 60).toFixed(2);
  var minutes = value % 60;
  return `${Hours} : ${minutes}`;
}
const uploadImage = (event, mimeType, bucketType) => {
  return new Promise((resolve, reject) => {
    if (event.target.files && event.target.files.length) {
      let date = new Date();
      const name = date.getTime() + '.' + event.target.files[0].name?.split(".").pop();
      var reader = new FileReader();
      reader.onload = function () {
        API.post("getPreSignedURL", {
          fileName: name.trim(),
          mimeType: mimeType,
          bucketType: bucketType,
        })
          .then((response) => {
            fetch(response.data.data.preSignedUrl, {
              method: "PUT",
              body: new Blob([reader.result], {
                type: mimeType,
              }),
            })
              .then(() => {
                resolve(response.data);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            reject(error);
          });
      };
      reader.readAsArrayBuffer(event.target.files[0]);
    }
  });
};
const UploadFile = (event, fileName, defaultText, mimeType, bucketType) => {
  return new Promise((resolve, reject) => {
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      document.getElementById(fileName).innerHTML = file.name;
      let date = new Date();
      const name = date.getTime() + '.' + file.name.split(".").pop();
      var reader = new FileReader();
      reader.onload = function () {
        API.post("getPreSignedURL", {
          fileName: name.trim(),
          mimeType: mimeType,
          bucketType: bucketType,
        })
          .then((response) => {
            fetch(response.data.data.preSignedUrl, {
              method: "PUT",
              body: new Blob([reader.result], {
                type: mimeType,
              }),
            })
              .then(() => {
                resolve(response.data);
              })
              .catch((error) => {
                reject(error);
              });
          })
          .catch((error) => {
            reject(error);
          });
      };
      reader.readAsArrayBuffer(event.target.files[0]);
    } else {
      document.getElementById(fileName).innerHTML = defaultText;
    }
  });
};
const utcToLocal = (time, timezone, format) => {
  if (time) {
    let localTime = moment.tz(time, timezone).format(format);
    return localTime;
  } else {
    let localTime = moment.tz(timezone).format(format);
    return localTime;
  }
};

const utcToLocalTime = (time, timezone, format) => {
    const formatedTime = moment.tz(time, timezone).format("YYYY/MM/DD HH:mm:ss")
    if (time) {
      return formatedTime;
    }
    return "";
  };

const utcToTimezone = (time, timezone, format) => {
  if (time && format) {
    let localTime = moment.tz(time, timezone).format(format);
    return localTime;
  }
  return;
};

const utcToShortMonthDate = (time, timezone) => {
  if (time) {
    let formatTime = moment.tz(time, timezone).format("MMM DD, YYYY [at] HH:mm");
    return formatTime;
  }
  return;
};

const formatNetCharge = (netCharge) => {
  return Number(netCharge).toFixed(2);
}

const formatAustralianCurrency = (amount) => {
  return Number(amount).toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

const stripTrailingZeros = (value) => {
  if (typeof value !== 'string') {
    value = value.toString();
  }
  return value.replace(/\.00$/, '');
}

const convertMysqlDateToYYYYMMDD = (mysqlDate) => {
  const date = new Date(mysqlDate);
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getUTCDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

const utcToStartDateTimezone = (time, timezone, format) => {
  if (time && format) {
    const match = time.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      return moment.tz(`${time} 00:00`, timezone).format(format);
    }
    return
  }
};

const utcToEndDateTimezone = (time, timezone, format) => {
  if (time && format) {
    return moment.tz(`${time} 23:59`, timezone).format(format);
  }
  return;
};

const convertTempUnitToText = (unit) => {
  let text;
  if (unit.includes("C")) {
    text = "Celsius";
  } else if (unit.includes("K")) {
    text = "Kelvin";
  } else if (unit.includes("F")) {
    text = "Fahrenheit";
  } else {
    text = "Unknown unit";
  }
  return text;
}

const setInterstateMode = (mode, data, stringify) => {
  if (stringify) return localStorage.setItem(mode, JSON.stringify(data));
  else return localStorage.setItem(mode, data);
};
const getInterstateMode = (mode, parse) => {
  if (parse) {
    return JSON.parse(localStorage.getItem(mode));
  } else {
    return localStorage.getItem(mode);
  }
};

const removeInterstateMode = (mode) => {
  return localStorage.removeItem(mode);
};

const isSameDate = (dateA, dateB) => {
  const first = new Date(moment(dateA).format("YYYY-MM-DD"));
  const second = new Date(moment(dateB).format("YYYY-MM-DD"));

  if (first.getTime() === second.getTime()) {
    return true;
  }
  return false;
}

export {
  headerTop,
  setToken,
  getToken,
  removeToken,
  dashboardRequestStatusColors,
  dashboardRequestbButtonStyle,
  jobListingRequestStyle,
  allowOnlyNumbers,
  closeMobileMenu,
  makeid,
  requestStatusColors,
  getCustomDate,
  allowOnlyFloat,
  allowOnlyCharacters,
  convertMinutesToHours,
  UploadFile,
  setPermissions,
  getPermissions,
  removePermissions,
  getCustomFormToDate,
  setUserData,
  getUserData,
  removeUserData,
  allowAlphaNumeric,
  allowSomeSpecialChar,
  allowOnlyAlphaNumericNoSpecialChar,
  awbNumberValidation,
  uploadImage,
  setUserId,
  getUserId,
  utcToLocal,
  utcToLocalTime,
  averageMinutesToHours,
  setFilter,
  getFilter,
  removeFilter,
  allowOnlyFloatFour,
  allowNegativeOnlyFloat,
  utcToTimezone,
  pathValidation,
  allowNumberWithSpaceValidation,
  isRolePermission,
  actionFromPermission,
  formatNetCharge,
  convertMysqlDateToYYYYMMDD,
  allowPasteAlphaNumeric,
  allowPasteNumberWithSpaceValidation,
  convertTempUnitToText,
  getCustomFormToDateFormat,
  setInterstateMode,
  getInterstateMode,
  removeInterstateMode,
  isSameDate,
  formatAustralianCurrency,
  stripTrailingZeros,
  utcToStartDateTimezone,
  utcToEndDateTimezone,
  utcToShortMonthDate
};
